"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGraphContent = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const buildError_1 = tslib_1.__importDefault(require("../clients/errorHandling/buildError"));
const handleServerError_1 = tslib_1.__importDefault(require("../clients/errorHandling/handleServerError"));
const tracker_1 = require("./utils/tracker");
const getGraphContent = async ({ space, accessToken, host = 'graphql.contentful.com', environment = 'master', query, trackingApplicationName }) => {
    const url = `https://${host}/content/v1/spaces/${space}/environments/${environment}`;
    try {
        const response = await (0, axios_1.default)({
            url,
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            },
            data: {
                query
            }
        });
        void (0, tracker_1.trackGQLData)(response.data, trackingApplicationName, space);
        return response.data;
    }
    catch (err) {
        if (err === null || err === void 0 ? void 0 : err.isAxiosError) {
            const { response: axiosResponse } = err;
            if (axiosResponse) {
                const { status, statusText, data } = axiosResponse;
                throw (0, buildError_1.default)(status, statusText !== null && statusText !== void 0 ? statusText : err.message, url, {}, {}, data);
            }
            else {
                // Handle the case where axiosResponse is undefined
                (0, handleServerError_1.default)('Undefined axiosResponse', url, {});
            }
        }
        else {
            // Handle non-Axios errors
            (0, handleServerError_1.default)(err.message, url, {});
        }
    }
};
exports.getGraphContent = getGraphContent;
//# sourceMappingURL=getGraphContent.js.map